import React from "react";  
import { Typography, Box, Button, Grid, Paper } from "@mui/material";  
import { motion } from "framer-motion";    
import References from "./References"; // References bileşenini import ettik
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t, i18n } = useTranslation();  // i18n kullanarak çeviri fonksiyonunu alıyoruz.
  const navigate = useNavigate();  // React Router kullanarak navigate fonksiyonunu alıyoruz.

  const features = [
    {  
      title: t("home.feature1.title"),  // Çeviriyi burada dinamik hale getiriyoruz.
      desc: t("home.feature1.desc"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ikon1.png",
    },  
    {  
      title: t("home.feature2.title"),
      desc: t("home.feature2.desc"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ikon5.png",  
    },  
    {  
      title: t("home.feature3.title"),
      desc: t("home.feature3.desc"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ikon2.png",  
    },  
    {  
      title: t("home.feature4.title"),
      desc: t("home.feature4.desc"), 
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ikon4.png",  
    },  
    {  
      title: t("home.feature5.title"),
      desc: t("home.feature5.desc"),
      icon: "🛡️",  
    },  
    {  
      title: t("home.feature6.title"),
      desc: t("home.feature6.desc"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/ikon3.png",  
    },  
  ];

const ProductFeatures = () => {
  return (
    <Box sx={{ py: 5, backgroundColor: "#FFFFFF", borderRadius: "20px", padding: "40px", boxShadow: "0px 8px 30px rgba(0,0,0,0.1)" }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1.8rem", md: "2.4rem" },
          color: "#000000",
          textAlign: "center",
          mb: 5,
          textShadow: "2px 2px 5px rgba(0, 0, 0, 0)",
        }}
      >
      {t('home.productFeaturesTitle')}
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
              <Paper
                elevation={3}
                sx={{
                  textAlign: "center",
                  padding: "30px",
                  borderRadius: "20px",
                  background: "#FFFFFF",
                  height: "300px",
                  transition: "transform 0.3s",
                  position: "relative",
                  overflow: "hidden",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Box sx={{ fontSize: "4rem", marginBottom: "15px" }}>
                  {feature.image ? (
                    <img src={feature.image} alt={feature.title} style={{ width: "80px", height: "80px", objectFit: "contain" }} />
                  ) : (
                    feature.icon
                  )}
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "#333", padding: "0 15px", fontWeight: 500 }}>
                  {feature.desc}
                </Typography>

                <Box
                  sx={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0, 114, 255, 0.1)",
                    transition: "all 0.3s",
                    zIndex: -1,
                    "&:hover": {
                      backgroundColor: "rgba(0, 114, 255, 0.2)",
                    },
                  }}
                />
              </Paper>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};




  return (  
    
    <div style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", fontFamily: "Poppins, sans-serif" }}>  
<Box  
  sx={{  
    height: "100dvh",  
    backgroundImage: `url('https://www.remora.com.tr/wp-content/uploads/2025/05/new-background.jpg.jpg')`,  
    backgroundSize: "cover",  
    backgroundPosition: "center",  
    backgroundRepeat: "no-repeat",  
    display: "flex",  
    flexDirection: "column",  
    alignItems: "center",  
    justifyContent: "center",  
    color: "white",  
    position: "relative",  
    overflow: "hidden",  
    
    // Mobil için özel stiller
    "@media (max-width: 600px)": {
      backgroundSize: "200%",  // Mobilde biraz daha büyük göster  
      backgroundPosition: "center",  // Resmi tam ortada tut  
    },
  }}  
>


  <motion.div>  
    <Typography  
      variant="h2"  
      gutterBottom  
      sx={{  
        fontSize: { xs: "2.2rem", md: "4rem" },  
        fontWeight: 900,  
        letterSpacing: ".1rem",  
        color: "#FFFFFF",  
        textShadow: "4px 4px 20px rgba(0, 0, 0, 0.7)",  
        marginBottom: "10px",  
        marginTop: { xs: "-120px", md: "-70px" },  // Mobilde daha yukarı çekildi  
      }}  
    >  
     {t('home.productTitle')}
    </Typography>  
  </motion.div>  

  <motion.div>  
    <Typography  
      variant="h6"  
      sx={{  
        fontWeight: 400,  
        marginBottom: "20px",  
        maxWidth: "600px",  
        fontStyle: "italic",  
        fontSize: { xs: "1.2rem", md: "1.8rem" },  
        color: "#FFFFFF",  
        textShadow: "2px 2px 12px rgba(0, 0, 0, 0.5)",  
        marginTop: { xs: "-80px", md: "-20px" },  
        textAlign: { xs: "center", md: "left" },
      }}  
    >  
    {t('home.productTitle2')}
     
    </Typography>  
  </motion.div>  

 
<motion.div whileHover={{ scale: 1.1 }} transition={{ duration: 0.3 }}>
  <Button  
    variant="contained"  
    size="large"  
    onClick={() => navigate("/urunler")} // Yönlendirme
    sx={{  
      marginTop: { xs: "-20px", md: "5px" },  
      background: "linear-gradient(45deg, #00c6ff, #0072ff)",  
      color: "white",  
      padding: "12px 30px",  
      fontWeight: 700,  
      borderRadius: "30px",  
      "&:hover": { background: "linear-gradient(45deg, #0072ff, #00c6ff)", transform: 'translateY(-3px)' },  
      boxShadow: "0px 4px 15px rgba(0, 114, 255, 0.5)",  
      textTransform: "uppercase",  
    }}  
  >  
  {t('home.button')} 
  </Button>
</motion.div>
</Box>




    

      {/* Ürün Bilgisi ve Görsel Bölümü */}  
      <Box  
        sx={{  
          display: "flex",  
          flexDirection: { xs: "column", md: "row" },  
          alignItems: "center",  
          justifyContent: "space-between",  
          padding: "40px",  
          backgroundColor: "#FFFFFF",  
          boxShadow: "0px 8px 30px rgba(0,0,0,0.1)",  
          borderRadius: "20px",  
          margin: "40px auto",  
          maxWidth: "1200px",  
        }}  
      >  
        <motion.img  
         img src= "https://www.remora.com.tr/wp-content/uploads/2025/05/netapro.png" alt="Netapro" 

          style={{  
            width: "100%",  
            maxWidth: "600px",  
            borderRadius: "20px",  
            boxShadow: "0px 12px 30px rgba(0,0,0,0.1)",  
          }}  
          whileHover={{ scale: 1.05 }}  
          whileTap={{ scale: 0.95 }}  
          transition={{ duration: 0.3 }}  
        />  

        <motion.div style={{ textAlign: "center", marginTop: "30px", maxWidth: "500px" }}  
          whileInView={{ opacity: 1 }}  
          initial={{ opacity: 0 }}  
          transition={{ duration: 1.2, delay: 0.3 }}  
        >  
          <Typography  
            variant="h4"  
            sx={{  
              fontWeight: 700,  
              fontSize: { xs: "2rem", md: "2.8rem" },  
              marginBottom: "15px",  
              color: "#000000",  
            }}  
          >  
           {t('home.title3')} 
           
          </Typography>  
          <Typography  
            variant="body1"  
            sx={{  
              color: "#000000",  
              fontSize: { xs: "1rem", md: "1.2rem" },  
              marginBottom: "25px",  
            }}  
          >  
           {t('home.title3.text')} 
          
          </Typography>  
        </motion.div>  
      </Box>  

      <ProductFeatures />  

      {/* Yeni Referanslar Bölümü Ekleniyor */}  
      <References /> {/* Burada Referanslar bileşeni kullanılıyor */}  
    
    </div>  
    
  );  
};  

export default Home;
